import React from 'react';
// import NoOpeningGif from "../../../resources/images/noOpeningAvailable.gif"
import NoVacancies from "../../../resources/images/no-job-vacancies.gif"

const NoJobAvailable = () => {
  return (
 <div className="empty-state">
   <div className="empty-state__content">
     <div style={{width:'100%',height:'50vh',flexDirection: 'column'}} className="empty-state__icon_notFound">
       <img
         src={NoVacancies}
         alt="No Openings Available"
         style={{height:'25rem'}}
       />
     </div>
   </div>
 </div>
  )
}

export default NoJobAvailable;